import { UseFormWatch } from 'react-hook-form';
import SeverityRenderer from 'shared/components/SeverityRenderer';
import { AddTestForm } from 'shared/types';
import { getConditionalSeverityString } from 'testManagement/utils/utils';

type Props = {
  watch: UseFormWatch<AddTestForm>;
};

const ColumnsUniqueConfig = ({ watch }: Props) => {
  const { warnIf, errorIf } = getConditionalSeverityString(watch('severity'));

  return (
    <SeverityRenderer
      severity={watch('severity')?.type || 'error'}
      warnIf={warnIf}
      errorIf={errorIf}
    />
  );
};

export default ColumnsUniqueConfig;
